@if (!appSettings.isMobile()) {
    <div class="row mb-3 align-items-end g-2">
        <div class="col-md-4">
            <label class="form-label small text-muted mb-1">Buscar</label>
            <input type="text" class="form-control" placeholder="Nombre, slug o abreviatura"
                [(ngModel)]="searchText">
        </div>
        <div class="col-md-8 d-flex justify-content-end">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="load()" [disabled]="loading()">
                <i class="fas fa-sync-alt me-1" [class.fa-spin]="loading()"></i> Actualizar
            </button>
        </div>
    </div>

    <div class="table-responsive table-data mb-0">
        <table class="table table-hover table-sm align-middle">
            <thead>
                <tr>
                    <th>Proceso</th>
                    <th class="text-center">Requisitos</th>
                    <th>Último cambio</th>
                    <th>Usuario</th>
                    <th class="text-end">Acciones</th>
                </tr>
            </thead>
            <tbody>
                @if (loading()) {
                    @for (i of skeletonRows; track i) {
                        <tr>
                            @for (c of [1,2,3,4,5]; track c) {
                                <td><p class="p-skeleton m-1" style="width: 100%; height: 12px;"></p></td>
                            }
                        </tr>
                    }
                } @else {
                    @for (proc of filteredRows(); track proc.uuid || proc.id || proc.slug) {
                        <tr>
                            <td>
                                <div class="d-flex align-items-center gap-2">
                                    @if (proc.icon) {
                                        <i [class]="proc.icon + ' text-secondary'"></i>
                                    }
                                    <div>
                                        <div class="fw-semibold">{{ proc.name }}</div>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">
                                @if (proc.reqCount > 0) {
                                    <span class="badge text-secondary border">{{ proc.reqCount }}</span>
                                } @else {
                                    <span class="text-muted small">Sin requisitos</span>
                                }
                            </td>
                            <td>
                                @if (proc.lastAudit; as audit) {
                                    <div class="small">{{ audit.actionLabel }}</div>
                                    <div class="text-muted small">{{ formatWhen(audit.createdAt) }}</div>
                                } @else {
                                    <span class="text-muted small">Sin historial</span>
                                }
                            </td>
                            <td>
                                @if (proc.lastAudit?.userName) {
                                    {{ proc.lastAudit.userName }}
                                } @else if (proc.lastAudit?.roleName) {
                                    {{ proc.lastAudit.roleName }}
                                } @else {
                                    <span class="text-muted">—</span>
                                }
                            </td>
                            <td class="text-end text-nowrap">
                                <button type="button" class="btn btn-outline-primary btn-xs"
                                    title="Ver requisitos"
                                    (click)="viewProcess(proc)">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="5" class="text-center text-muted py-4">
                                No hay procesos para mostrar.
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>
} @else {
    <app-mobile-footer>
        <input type="search"
               class="form-control mobile-footer-search"
               placeholder="Buscar nombre, slug o abreviatura..."
               [(ngModel)]="searchText">
    </app-mobile-footer>
    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <span class="small text-muted fw-bold text-uppercase">
            REGISTROS @if (!loading()) { ({{ filteredRows().length }}) }
        </span>
        <button type="button" class="btn btn-link btn-sm text-decoration-none p-0"
            (click)="load()" [disabled]="loading()">
            <i class="fas fa-sync-alt" [class.fa-spin]="loading()"></i>
        </button>
    </div>

    <div class="mobile-cards-scroll">
        @if (loading()) {
            @for (i of skeletonRows; track i) {
                <app-list-card [isLoading]="true"></app-list-card>
            }
        } @else {
            @for (proc of filteredRows(); track proc.uuid || proc.id || proc.slug) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="viewProcess(proc)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        <i [class]="(proc.icon || 'fas fa-file-signature') + ' me-1 text-secondary'"></i>
                        {{ proc.name }}
                    </div>
                    <div cardBadge>
                        @if (proc.reqCount > 0) {
                            <span class="badge text-bg-light border">{{ proc.reqCount }} req.</span>
                        } @else {
                            <span class="badge text-bg-secondary">Sin requisitos</span>
                        }
                    </div>

                    <div class="row g-1 text-muted small">
                        <div class="col-12">
                            <span class="text-muted">Último cambio</span>
                            @if (proc.lastAudit; as audit) {
                                <div class="fw-semibold text-dark">{{ audit.actionLabel }}</div>
                                <div>{{ formatWhen(audit.createdAt) }}</div>
                            } @else {
                                <div class="fw-semibold text-dark">Sin historial</div>
                            }
                        </div>
                        <div class="col-12 mt-1">
                            <span class="text-muted">Usuario</span>
                            <div class="fw-semibold text-dark">
                                {{ proc.lastAudit?.userName || proc.lastAudit?.roleName || '—' }}
                            </div>
                        </div>
                    </div>
                </app-list-card>
            }
        }

        @if (!loading() && filteredRows().length === 0) {
            <div class="card border-0 shadow-sm p-4 text-center my-2">
                <i class="fas fa-file-signature fa-3x text-muted opacity-50 mb-2"></i>
                <h6 class="text-muted mb-1">Sin procesos</h6>
                <small class="text-muted">Ajusta la búsqueda o crea procesos primero.</small>
            </div>
        }
    </div>
}
